module.exports = __webpack_public_path__ + "static/img/flag_1.1489fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag_1.png
// module id = DJzx
// module chunks = 1